import React, { useState, useEffect } from 'react';
import styled, { keyframes, css } from 'styled-components';

const TOTAL_SLIDES = 40;
const INTERVAL_MS = 15000;
const FADE_MS = 2000;
const BASE_URL = 'https://belvoircastlepull.b-cdn.net/Caroline%20Screen/Slide';

const fadeInAnim = keyframes`
  from { opacity: 0; }
  to   { opacity: 1; }
`;

const fadeOutAnim = keyframes`
  from { opacity: 1; }
  to   { opacity: 0; }
`;

const Wrapper = styled.div`
  position: fixed;
  inset: 0;
  background: #000;
  overflow: hidden;
`;

const Slide = styled.div`
  position: absolute;
  inset: 0;
  background-image: url(${({ $src }) => $src});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  ${({ $state }) =>
    $state === 'in' &&
    css`
      animation: ${fadeInAnim} ${FADE_MS}ms ease-in-out forwards;
    `}
  ${({ $state }) =>
    $state === 'out' &&
    css`
      animation: ${fadeOutAnim} ${FADE_MS}ms ease-in-out forwards;
    `}
`;

const CarolineScreen = () => {
  const [slides, setSlides] = useState([{ id: 1, index: 1, state: 'in' }]);

  useEffect(() => {
    let id = 1;
    const timer = setInterval(() => {
      id += 1;
      const nextIndex = ((id - 1) % TOTAL_SLIDES) + 1;

      setSlides(prev => {
        const updated = prev.map(s => ({ ...s, state: 'out' }));
        return [...updated, { id, index: nextIndex, state: 'in' }];
      });

      // Remove the outgoing slide after the fade completes
      setTimeout(() => {
        setSlides(prev => prev.filter(s => s.state !== 'out'));
      }, FADE_MS + 50);
    }, INTERVAL_MS);

    return () => clearInterval(timer);
  }, []);

  return (
    <Wrapper>
      {slides.map(slide => (
        <Slide
          key={slide.id}
          $src={`${BASE_URL}${slide.index}.jpg`}
          $state={slide.state}
        />
      ))}
    </Wrapper>
  );
};

export default CarolineScreen;
